import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LimitUpDirective } from '@core/directives/screen-view/limit-up.directive';
import { SmallerThanDirective } from '@core/directives/screen-view/smaller-than.directive';

@NgModule({
  imports: [CommonModule, LimitUpDirective, SmallerThanDirective],
  exports: [SmallerThanDirective, LimitUpDirective],
})
export class ScreenViewModule {}
